module.exports = __webpack_public_path__ + "static/media/no-property-image.3cb3e3c5.svg";